
export type RolesPayload = {

    roleName: string;
    permissions?: string[];

}


export enum RoleNames {
    SUPER_ADMIN = "Super Admin",
    ADMIN = "Admin",
    UNION_LEADER = "Union Leader"
}
